import React from 'react';
import clsx from 'clsx';
import { Card as CardRoot } from '@wix/design-system';
import styles from './Card.scss';
export function Card(_ref) {
  let {
    children,
    footer,
    className,
    footerClassName,
    contentClassName
  } = _ref;
  return /*#__PURE__*/React.createElement(CardRoot, {
    className: clsx(styles.wrapper, className)
  }, /*#__PURE__*/React.createElement("div", {
    className: clsx(styles.content, contentClassName)
  }, children), footer && /*#__PURE__*/React.createElement("div", {
    className: clsx(styles.footer, footerClassName)
  }, footer));
}
//# sourceMappingURL=Card.js.map